import { ArrowLeftOutlined, EditOutlined } from '@ant-design/icons'
import { useHistory, useParams } from 'react-router-dom'
import {
  Button,
  Card,
  Col,
  ContentBody,
  ContentHeader,
  Row,
  ListItem,
  Table
} from '../../../core/components'
import { Tabs } from 'antd'
import { dateTimeFormat } from '../../../utils/format/dateTimeFormat'
import { dateFormat } from '../../../utils/format/dateFormat'
import { useEffect, useMemo, useState } from 'react'
import useServiceOrderById from '../../../services/queries/serviceOrders/useServiceOrder'
import { formatCurrency } from '../../../utils/format/currencyFormat'
import { dateAndTimeFormat } from '../../../utils/format/dateAndTimeFormat'

const { TabPane } = Tabs

interface DataType {
  key: React.Key
  name: string
  age: number
  address: string
}

export const DetailServiceOrder = () => {
  const { goBack } = useHistory()
  const { id }: any = useParams()
  const [item, setItem] = useState<any>({})
  const [selectedRowKeys, setSelectedRowKeys] = useState<any>([])

  const {
    data: serviceOrder,
    error,
    isLoading
  }: any = useServiceOrderById({ id })

  const columns = useMemo(
    () => [
      {
        title: 'Cód do Produto',
        dataIndex: 'id',
        key: 'id'
      },
      {
        title: 'Descrição',
        dataIndex: 'name'
      },
      {
        title: 'Número de Série',
        dataIndex: 'serialNumber'
      },
      // {
      //   title: 'Assunto',
      //   dataIndex: 'subject'
      // },
      {
        title: 'Situação',
        dataIndex: 'situation'
      },
      {
        title: 'Data',
        dataIndex: 'date',
        render: (value: any) => dateTimeFormat(value)
      }
    ],
    []
  )

  const rowSelection = useMemo(
    () => ({
      onChange: (selectedRowKey: React.Key[], selectedRows: DataType[]) => {
        setItem(selectedRows[0])
        setSelectedRowKeys(selectedRowKey)
      }
    }),
    []
  )

  useEffect(() => {
    setSelectedRowKeys([serviceOrder?.data?.items?.[0]?.id] || [])
    setItem(serviceOrder?.data?.items?.[0])
  }, [serviceOrder])

  if (isLoading) {
    return null
  }

  if (error) {
    return <div>ALGUM ERRO ACONTECEU</div>
  }

  return (
    <div>
      <ContentHeader>
        <Button type="text" onClick={goBack}>
          <ArrowLeftOutlined />
        </Button>
        Detalhes da Ordem de Serviço
      </ContentHeader>
      <ContentBody>
        <Tabs type="line">
          <TabPane tab="Geral" key="1">
            <Card>
              <div style={{ fontSize: '16px' }}>
                <Row>
                  <Col span={12}>
                    <ListItem label="NÚMERO">{serviceOrder?.data?.id}</ListItem>
                    <ListItem label="DATA">
                      {dateAndTimeFormat(
                        serviceOrder?.data?.date,
                        serviceOrder?.data?.time
                      )}
                    </ListItem>
                    <ListItem label="UNIDADE DE NÉG">
                      {serviceOrder?.data?.unity?.name}
                    </ListItem>
                    <ListItem label="CLIENTE">
                      {serviceOrder?.data?.customer?.id} -{' '}
                      {serviceOrder?.data?.customer?.name}
                    </ListItem>
                    <ListItem label="CONTATO">
                      {serviceOrder?.data?.contact}
                    </ListItem>
                    <ListItem label="RESPONSÁVEL">
                      {serviceOrder?.data?.responsible?.id} -{' '}
                      {serviceOrder?.data?.responsible?.name}
                    </ListItem>
                    <ListItem label="REPRESENTANTE">
                      {serviceOrder?.data?.salesman?.id} -{' '}
                      {serviceOrder?.data?.salesman?.name}
                    </ListItem>
                  </Col>
                  <Col span={12}>
                    <ListItem label="OBSERVAÇÃO">
                      {serviceOrder?.data?.observation}
                    </ListItem>
                    <ListItem label="REQUISIÇÃO">
                      {serviceOrder?.data?.requisition}
                    </ListItem>
                    <ListItem label="SITUAÇÃO">
                      {serviceOrder?.data?.situation}
                    </ListItem>
                    <ListItem label="PRIORIDADE">
                      {serviceOrder?.data?.priority}
                    </ListItem>
                    <ListItem label="VALOR TOTAL DA O.S.">
                      {formatCurrency(serviceOrder?.data?.osTotalValue)}
                    </ListItem>
                  </Col>
                </Row>
              </div>
            </Card>
          </TabPane>
          <TabPane tab="Item" key="2">
            <Table
              dataSource={serviceOrder?.data?.items || []}
              columns={columns}
              rowKey="id"
              bordered
              onRow={(record) => {
                return {
                  onClick: () => {
                    setItem(record)
                    setSelectedRowKeys([record.id])
                  }
                }
              }}
              rowSelection={{
                selectedRowKeys,
                type: 'radio',
                ...rowSelection
              }}
            />
            <Row>
              <Col span={12}>
                <ListItem label="IDENTIFICAÇÃO">
                  {item?.identification}
                </ListItem>

                <ListItem label="ÚLTIMO ATENDIMENTO">
                  {dateFormat(item?.lastContact)}
                </ListItem>
                <ListItem label="PRIORIDADE">{item?.priority}</ListItem>
                <ListItem label="PRAZO PROGRAMADO">
                  {dateFormat(item?.deadline)}
                </ListItem>
              </Col>
              <Col span={12}>
                <ListItem label="CONCLUSÃO">
                  {dateAndTimeFormat(
                    item?.conclusionDate,
                    item?.conclusionTime
                  )}
                </ListItem>
                <ListItem label="TIPO">{item?.type?.name}</ListItem>
                <ListItem label="VERSÃO">{item?.version}</ListItem>
                <ListItem label="DESCRIÇÃO DA SOLUÇÃO">
                  {item?.solutionDescription}
                </ListItem>
                <ListItem label="DESCRIÇÃO DA SOLICITAÇÃO">
                  {item?.requestDescription}
                </ListItem>
                <ListItem label="OBSERVAÇÃO DA SOLICITAÇÃO">
                  {item?.observation}
                </ListItem>
              </Col>
            </Row>
          </TabPane>
        </Tabs>
      </ContentBody>
    </div>
  )
}
